// extracted by mini-css-extract-plugin
export default {"div":"CategoryMenu_div__y+mEF","category-menu":"CategoryMenu_category-menu__QEwuu","category-menu-active":"CategoryMenu_category-menu-active__wYniD"};